// src/features/payment/paymentService.js

const IYZI_LINKS = {
  individual_1_month: 'https://iyzi.link/AJbqsA',
  individual_6_month: 'https://iyzi.link/AJbqrg',
  individual_12_month: 'https://iyzi.link/AJbqrw',
  micro_business: 'https://iyzi.link/AJcB3g',
  small_business: 'https://iyzi.link/AJcB3w',
  medium_business: 'https://iyzi.link/AJ8yNA',
};

const initializePayment = async (paymentData) => {
  const planId = paymentData?.planId;
  const paymentUrl = IYZI_LINKS[planId];
  if (!paymentUrl) {
    throw new Error('Unknown payment plan');
  }

  // Simulate API delay (development only)
  await new Promise((resolve) => setTimeout(resolve, 1000));

  return {
    success: true,
    paymentPageUrl: paymentUrl,
    token: `mock_token_${Date.now()}`,
    conversationId: `conv_${Date.now()}`,
  };
};

const checkPaymentStatus = async (conversationId) => {
  if (!conversationId) {
    throw new Error('Conversation ID is required');
  }

  await new Promise((resolve) => setTimeout(resolve, 500));

  return {
    success: true,
    status: 'completed',
    paymentId: `payment_${Date.now()}`,
  };
};

const paymentService = {
  initializePayment,
  checkPaymentStatus,
  IYZI_LINKS,
};

export default paymentService;
